export default __webpack_public_path__ + "static/media/play_white.44e72efb.svg";